<template>
  <!--
      作者：kmdshop
      时间：2019-10-25
      描述：资金池
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="资金池名称">
          <el-input v-model="searchForm.name" placeholder="请输入资金池名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
        <el-table-column prop="funds_pool_id" label="ID" width="100"></el-table-column>
        <el-table-column prop="name" label="资金池名称"></el-table-column>
        <el-table-column prop="current_money" label="余额（本年）"></el-table-column>
        <el-table-column prop="describe" label="描述/说明"></el-table-column>
        <el-table-column fixed="right" label="操作" width="250">
          <template slot-scope="{row}">
            <el-button type="text" size="small" @click="detailClick(row)">资金明细</el-button>
            <el-button type="text" size="small" @click="reduceClick(row)">调整</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="pagingObj.curPage" :page-size="pagingObj.pageSize" :page-sizes="[5, 10, 20, 50, 100]" layout="total, sizes, prev, pager, next, jumper" :total="pagingObj.totalDataNumber"></el-pagination>
      </div>
    </div>

    <!--资金减少弹窗-->
    <Recharge v-if="open_add" :open_add="open_add" :item="item"  @closeDialog="closeDialogFunc($event, 'reduce')"></Recharge>
  </div>
</template>

<script>
import Recharge from './dialog/Recharge.vue';
import UserApi from '@/api/user.js';
export default {
  components: {
    Recharge,
  },
  data() {
    return {
      /*是否加载完成*/
      loading: false,
      /*列表数据*/
      tableData: [],
      // 分页对象
      pagingObj: {
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
      },
      /*横向表单数据模型*/
      searchForm: {
        name: '',
      },
      /*是否打开添加弹窗*/
      open_add: false,
      item: {},
    }
  },
  created() {
    /*获取列表*/
    this.getData()
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this
      self.pagingObj.curPage = val
      self.getData()
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.pagingObj.curPage = 1
      this.pagingObj.pageSize = val
      this.getData()
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this
      self.pagingObj.curPage = 1
      self.getData()
    },

    /*获取列表*/
    getData() {
      let self = this
      self.loading = true
      UserApi.fundsPoolList(self.searchForm)
        .then(res => {
          self.tableData = res.data.list.data
          self.pagingObj.totalDataNumber = res.data.list.total
          self.loading = false
        })
        .catch(error => {})
    },
    /*打开明细*/
    detailClick(row) {
      this.$router.push({
        path: '/user/fundpool/detail',
        query: {
          funds_pool_id: row.funds_pool_id
        }
      })
    },
    /*减少*/
    reduceClick(item){
      this.item = item;
      this.open_add = true;
    },
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'reduce') {
        this.open_add = e.openDialog;
        if (e.type == 'success') {
          this.getData();
        }
      }
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1
      this.tableData = []
      this.getData()
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/user/fundpool/list.vue